import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import LoadingOutlined from "@ant-design/icons/LoadingOutlined";
import {
  setActiveSectionKey,
  setFilterObject,
} from "../../../redux/actions/section/section";
import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import Widget from "./Widget";
import WidgetFilter from "../../../assets/WidgetFilter.svg";
import filterWhite from "../../../assets/WhiteIcons/filterIconWhite.svg";
import durationIcon from "../../../assets/calendarIconLB.svg";
import durationIconGold from "../../../assets/calendarIconLB_gold.svg";
import durationWhiteIcon from "../../../assets/WhiteIcons/calendarWhiteIconLB.svg";
import WidgetFilterLockIcon from "../../../assets/filterLockIcon.svg";
import Default_Brand from "../../../assets/brandLogos/Default_Brand.svg";
import {
  getBrands,
  getGlobalBrands,
  getMtdYtdDuration,
  getPaneIndex,
} from "../../../redux/constants";
import { Tooltip, Avatar, Popover, Badge, Spin, Image } from "antd";
import EditWidget from "./Widget/editWidget";
import { setEditPanel } from "../../../redux/actions/dashboard/dashboard";
import { setIsWidgetEdit } from "../../../redux/actions/Filter";
import moment from "moment";
import accoArrow from "../../../assets/acco_arrow-up.svg";
import accoArrowWhite from "../../../assets/WhiteIcons/acco_arrow-upWhite.svg";

import filterSmall from "../../../assets/filterIcon.svg";
import { updateDashboardSectionOpen } from "../../../redux/actions/dashboard/Tab1";
import isEqual from "react-fast-compare";

const antIcon = (
  <LoadingOutlined
    style={{
      fontSize: 24,
    }}
    spin
  />
);
const SectionInsights = ({
  title,
  description,
  widgets,
  section_index,
  section_id,
  sections,
  comprtitorBrandFilter,
}) => {
  const dispatch = useDispatch();
  const [columnSpan, setColumnSpan] = useState("full");
  const Allbrands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );
  const templateSectionFetchLoader = useSelector(
    (state) => state.ApiCall.templateSectionFetchLoader
  ); //display chart loader
  const brandlogicalgroup = useSelector(
    (state) => state.ApiCall.brandlogicalgroup?.data?.result
  );
  const isWidgetEdit = useSelector((state) => state.Filter.isWidgetEdit);
  const shareBrands = useSelector((state) => state.ApiCall.shareBrands);
  const All_Share_attributes = useSelector(
    (state) => state.WidgetMaker.All_Share_attributes
  );
  const global_dashboard_brands = useSelector(
    (state) => state.AuthParams.global_dashboard_brands
  );
  const global_dashboard_single_brands = useSelector(
    (state) => state.AuthParams.global_dashboard_single_brands
  );
  const authParams = useSelector((state) => state.Authentication.authParams);

  const shareTemplateData = useSelector(
    (state) => state.ApiCall.shareTemplateData
  );
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  const panes = useSelector((state) => state?.Tab1?.panes);
  let index = getPaneIndex(panes, activeKey);
  const PdfDownloadStatus = useSelector(
    (state) => state.PdfDownloadData.PdfDownloadStatus
  );
  const aggregateLoader = useSelector((state) => state.apiCall.aggregateLoader);
  const graphLoader = useSelector((state) => state.apiCall.loader);
  const profileLoader = useSelector((state) => state.apiCall.profileLoader);
  const pdfEditorPanelSatus = useSelector(
    (state) => state?.scheduleReport?.templateObj?.pdfEditorPanelSatus
  );

  let section_brands =
    section_index >= 0
      ? panes[index]?.sections &&
        panes[index]?.sections[section_index] &&
        panes[index]?.sections[section_index]?.brand_ids
      : [null, undefined]?.includes(section_index) &&
        panes[index]?.section &&
        panes[index]?.section[0]
      ? panes[index]?.section[0]?.brand_ids
      : null;
  let share_section_brands =
    section_index >= 0
      ? shareTemplateData?.sections &&
        shareTemplateData?.sections[section_index] &&
        shareTemplateData?.sections[section_index]?.brand_ids
      : [null, undefined]?.includes(section_index) &&
        shareTemplateData?.sections &&
        shareTemplateData?.sections[0]
      ? shareTemplateData?.sections[0]?.brand_ids
      : null;
  let section_logical_brands =
    section_index >= 0
      ? panes[index]?.sections &&
        panes[index]?.sections[section_index] &&
        panes[index]?.sections[section_index]?.brand_groups
      : !section_index && panes[index]?.section && panes[index]?.section[0]
      ? panes[index]?.section[0]?.brand_groups
      : null;

  let share_section_logical_brands =
    section_index >= 0
      ? shareTemplateData?.sections &&
        shareTemplateData?.sections[section_index] &&
        shareTemplateData?.sections[section_index]?.brand_groups
      : !section_index &&
        shareTemplateData?.sections &&
        shareTemplateData?.sections[0]
      ? shareTemplateData?.sections[0]?.brand_groups
      : null;

  let finalBrand_list = getBrands(
    brandlogicalgroup ? brandlogicalgroup : shareBrands?.brand_groups,
    shareBrands ? share_section_brands : section_brands,
    Allbrands ? Allbrands : shareBrands?.brand_list,
    shareBrands ? share_section_logical_brands : section_logical_brands
  );

  const divRef = useRef();
  // let dateFilter = sections && sections[section_index]?.start_date ? 1 : 0;
  // let brandFilter =
  //   sections &&
  //   (sections[section_index]?.brand_ids ||
  //     sections[section_index]?.brand_groups)
  //     ? 1
  //     : 0;
  let filters =
    sections && sections[section_index]?.filters
      ? sections[section_index]?.filters?.filter((e) => e !== "BrandID")?.length
      : 0;

  let badgeCount = filters;
  const templateAccessType = panes[index].access_type;

  const setdivHeightRange = () => {
    sections?.map((el, i) => {
      if (el.section_id === section_id) {
        return (el.divHeight = divRef?.current?.clientHeight);
      } else return null;
    });
    let divHeight = sections?.map((el) => {
      return el.divHeight;
    });
    let arr = [];
    divHeight?.forEach((el, i) => {
      if (i === 0) {
        arr.push({ start: 0, end: el });
      } else {
        let value = { start: arr[i - 1].end, end: arr[i - 1].end + el };
        arr.push(value);
      }
    });

    return arr;
  };

  const setActivekey = (top, arr) => {
    arr?.forEach((el, i) => {
      if (top >= el?.start && top < el?.end) {
        dispatch(setActiveSectionKey(sections[i].section_id));
      }
    });
  };

  useScrollPosition(
    ({ currPos }) => {
      const arr = setdivHeightRange();
      setActivekey(window.pageYOffset, arr);
    },
    [sections],
    divRef,
    false,
    100
  );

  const handleFilter = () => {
    dispatch(setIsWidgetEdit(true));
    dispatch(
      setFilterObject(
        {
          id: section_id,
          type: "sectionFilter",
          section_index: section_index,
          widget_index: null,
        },
        panes[index].sections[section_index].is_locked
      )
    );

    let obj = {
      section_index: section_index,
      type: "dashboard_section",
    };

    dispatch(setEditPanel(obj));
  };

  const openSection = (section_index, type) => {
    if (type === "share") {
      let updateShareTemplateData = { ...shareTemplateData };
      let section_open = shareTemplateData?.sections?.[section_index]?.open;
      if (section_open && updateShareTemplateData.sections) {
        updateShareTemplateData.sections[section_index].open = false;
      } else if (updateShareTemplateData.sections) {
        updateShareTemplateData.sections[section_index].open = true;
      }
      dispatch({
        type: "SET_SHARE_TEMPLATE_DATA",
        payload: updateShareTemplateData,
      });
    } else {
      let section_open = panes[index]?.sections
        ? panes[index]?.sections?.[section_index]?.open
        : panes[index]?.section?.[0]?.open;
      dispatch(
        updateDashboardSectionOpen(
          section_open ? false : true,
          index,
          panes,
          section_index
        )
      );
    }
  };
  const getCompetitorBrandFilterPills = () => {
    let sectionComprtitorBrandTypeExists =
      comprtitorBrandFilter === false || comprtitorBrandFilter === true;
    let pillsList = [];
    if (sectionComprtitorBrandTypeExists) {
      let Section_is_locked = sections?.[section_index]?.is_locked;
      let sectionComprtitorBrandType = comprtitorBrandFilter;
      if (shareBrands) {
        let comBrand = shareBrands?.brands?.columns?.[0]?.competitor
          ? shareBrands?.brands?.columns?.[0]
          : shareBrands?.brands?.[0]?.competitor
          ? shareBrands?.brands?.[0]
          : shareBrands?.brands?.competitor
          ? shareBrands?.brands
          : null;
        let comBrandExists = comBrand?.competitor
          ? true
          : shareBrands
          ? shareBrands?.selected_brand_ids?.length &&
            shareBrands?.selected_comp_brand_ids?.length > 0
          : null;
        if (
          !(Section_is_locked && finalBrand_list?.columns?.length) &&
          comBrandExists
        ) {
          if (comBrand) {
            if (sectionComprtitorBrandType === false) {
              pillsList.push({
                brand_id: comBrand?.brand_id || comBrand?.name,
                brand_name: comBrand?.brand_name,
                brand_friendly_name: comBrand?.brand_friendly_name,
                brand_color: comBrand?.brand_color,
              });
            } else {
              comBrand?.competitorList?.forEach((competitorBrand) => {
                pillsList.push({
                  brand_id: competitorBrand?.brand_id,
                  brand_name: competitorBrand?.brand_name,
                  brand_friendly_name: competitorBrand?.brand_friendly_name,
                  brand_color: competitorBrand?.comp_brand_color,
                });
              });
            }
          } else {
            if (sectionComprtitorBrandType === false) {
              let parentB = shareBrands?.selected_brand_ids?.[0];
              pillsList.push({
                brand_id: parentB?.brand_id,
                brand_name: parentB?.brand_name,
                brand_friendly_name: parentB?.brand_friendly_name,
                brand_color: parentB?.brand_color,
              });
            } else {
              shareBrands?.selected_comp_brand_ids?.forEach(
                (competitorBrand) => {
                  pillsList.push({
                    brand_id: competitorBrand?.brand_id,
                    brand_name: competitorBrand?.brand_name,
                    brand_friendly_name: competitorBrand?.brand_friendly_name,
                    brand_color: competitorBrand?.comp_brand_color,
                  });
                }
              );
            }
          }
        }
      } else {
        // let global_brands = getGlobalBrands(
        //   panes?.[index]?.brands,
        //   global_dashboard_single_brands,
        //   global_dashboard_brands,
        //   panes?.[index]?.template_type
        // );
        let global_brands = panes?.[index]?.brands;
        let comBrand = global_brands?.columns?.[0]?.competitor
          ? global_brands?.columns?.[0]
          : global_brands?.[0]?.competitor
          ? global_brands?.[0]
          : global_brands?.competitor
          ? global_brands
          : null;

        if (
          !(Section_is_locked && finalBrand_list?.columns?.length) &&
          comBrand?.competitor
        ) {
          if (sectionComprtitorBrandType === false) {
            pillsList.push({
              brand_id: comBrand?.name,
              brand_name: comBrand?.brand_name,
              brand_friendly_name: comBrand?.brand_friendly_name,
              brand_color: comBrand?.brand_color,
            });
          } else {
            comBrand?.competitorList?.forEach((competitorBrand) => {
              pillsList.push({
                brand_id: competitorBrand?.brand_id,
                brand_name: competitorBrand?.brand_name,
                brand_friendly_name: competitorBrand?.brand_friendly_name,
                brand_color: competitorBrand?.comp_brand_color,
              });
            });
          }
        }
      }
    }
    return pillsList;
  };
  const competitorBrandFilterPills = getCompetitorBrandFilterPills();
  return (
    <>
      {templateSectionFetchLoader ? (
        <div
          className="loader text-center w-100"
          style={{ height: "calc(100vh - 15.2rem)" }}
        >
          <div className="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      ) : (
        <div ref={divRef} className={isWidgetEdit && "pr-0"}>
          {shareBrands ? (
            <>
              <div
                className={`section-title p-10 ${
                  authParams?.theme_type === "1" ? "" : "border"
                } border-color cursor-pointer border-radius-4 mb-15 ${
                  PdfDownloadStatus ? "d-none" : ""
                }`}
                onClick={() => openSection(section_index, "share")}
                // style={{
                //   backgroundColor:
                //     authParams?.theme_type === "1"
                //       ? "rgb(59 81 117 / 50%)"
                //       : "var(--locobuzz-secondary-bg-lighter-color)",
                // }}
              >
                <div className="row">
                  <div
                    className={`col-12 d-flex align-items-center flex-wrap ${
                      isWidgetEdit ? "col-md-12" : "col-md-9"
                    }`}
                  >
                    <div className="text_heading-Slab font-size16 font-weight500 d-inline-flex align-items-center">
                      {title}
                      <div
                        className="ml-15 d-inline-flex align-items-center"
                        //style={{ minHeight: "2.6rem" }}
                      >
                        {Array.isArray(competitorBrandFilterPills) &&
                          competitorBrandFilterPills?.map((comFil) => {
                            return (
                              <div
                                className="combrand__filter--pills border-radius-25 text-ellipsis"
                                style={{
                                  border: "0.1rem solid " + comFil?.brand_color,
                                }}
                              >
                                <Tooltip
                                  placement="topLeft"
                                  className="text-ellipsis d-block"
                                  title={comFil?.brand_friendly_name}
                                >
                                  <span>
                                    <span
                                      className="combrand__filter--color"
                                      style={
                                        comFil?.brand_color
                                          ? {
                                              backgroundColor:
                                                comFil?.brand_color,
                                            }
                                          : {
                                              border:
                                                "0.1rem solid var(--secondary-color)",
                                            }
                                      }
                                    ></span>
                                    <span className="">
                                      {comFil?.brand_friendly_name}
                                    </span>
                                  </span>
                                </Tooltip>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                    {description && (
                      <div className="text_regular font-size14 word-break w-100">
                        {description}
                      </div>
                    )}
                  </div>
                  <div
                    className={`col-12 col-md-3 text-right ${
                      isWidgetEdit
                        ? "d-none"
                        : "d-flex align-items-center justify-content-end"
                    }`}
                  >
                    {!shareTemplateData?.predefined && (
                      <Tooltip
                        overlayStyle={{
                          maxWidth: "20rem",
                        }}
                        color="#3B5175"
                        //className="custom_scroll"
                        placement="leftTop"
                        title={() => (
                          //todo
                          <div
                            className="custom_scroll"
                            style={{
                              maxWidth: "27rem",
                              maxHeight: "23rem",
                              overflow: "auto",
                              scrollBehavior: "smooth",
                            }}
                          >
                            {sections[section_index]?.brand_ids &&
                            sections[section_index]?.brand_ids?.columns
                              ?.length === shareBrands?.brand_list?.length
                              ? "All Brands selected"
                              : finalBrand_list
                              ? finalBrand_list?.columns?.map((el, index) => (
                                  <span
                                    key={index}
                                    style={{
                                      color: "#fff",
                                      maxHeight: "20rem",
                                      overflow: "auto",
                                    }}
                                  >
                                    {(index ? ", " : "") +
                                      el?.brand_friendly_name}
                                  </span>
                                ))
                              : "Section level brands"}
                          </div>
                        )}
                      >
                        <Badge
                          style={{
                            backgroundColor: "#185edf",
                            fontSize: "1rem",
                          }}
                          size="small"
                          count={finalBrand_list?.columns?.length}
                          className="mr-2 custom_scroll vertical-align-middle"
                        >
                          <button
                            className={`WidgetFilter ${
                              sections[section_index]?.is_locked &&
                              finalBrand_list?.columns?.length > 0
                                ? "locked"
                                : ""
                            }`}
                            onClick={(e) => {
                              e.stopPropagation();
                              e.nativeEvent?.stopImmediatePropagation();
                            }}
                            style={{
                              borderColor:
                                sections[section_index]?.is_locked &&
                                finalBrand_list?.columns?.length > 0
                                  ? "#efe3c0"
                                  : "",
                            }}
                          >
                            <Image
                              src={
                                finalBrand_list?.columns?.[0]?.group
                                  ? share_section_logical_brands?.filter(
                                      (el, i) =>
                                        el?.brand_group_name ===
                                        finalBrand_list?.columns?.[0]
                                          ?.brand_group_name
                                    )?.[0]?.brand_logo
                                    ? share_section_logical_brands?.filter(
                                        (el, i) =>
                                          el?.brand_group_name ===
                                          finalBrand_list?.columns?.[0]
                                            ?.brand_group_name
                                      )?.[0]?.brand_logo
                                    : Default_Brand
                                  : finalBrand_list?.columns?.length > 0
                                  ? finalBrand_list?.columns?.[0]?.brand_logo
                                  : Default_Brand
                              }
                              fallback={Default_Brand}
                              alt="Share Brand"
                              style={{ maxWidth: "1.6rem" }}
                              preview={false}
                            />
                          </button>
                        </Badge>
                      </Tooltip>
                    )}
                    {/* Last $
{moment(sections[section_index]?.start_date).diff(
moment(sections[section_index]?.end_date),
"days"
)}{" "}
days, */}
                    {!shareTemplateData?.predefined && (
                      <Tooltip
                        placement="leftTop"
                        overlayStyle={{ width: "23rem" }}
                        color="#3B5175"
                        title={
                          sections && sections[section_index]?.start_date
                            ? `
                          ${
                            moment(sections[section_index]?.start_date).format(
                              "MMM Do YYYY HH:mm"
                            ) + " to "
                          }
                      ${moment(sections[section_index]?.end_date).format(
                        "MMM Do YYYY HH:mm"
                      )}`
                            : "Section level duration"
                        }
                      >
                        <button
                          className={`WidgetFilter mr-2 ${
                            sections[section_index]?.is_locked &&
                            sections?.[section_index]?.start_date
                              ? "locked"
                              : ""
                          }`}
                          onClick={(e) => {
                            e.stopPropagation();
                            e.nativeEvent?.stopImmediatePropagation();
                          }}
                          style={{
                            borderColor:
                              sections[section_index]?.is_locked &&
                              sections?.[section_index]?.start_date
                                ? "#efe3c0"
                                : "",
                          }}
                        >
                          <img
                            src={
                              sections[section_index]?.is_locked &&
                              sections?.[section_index]?.start_date
                                ? durationIconGold
                                : authParams?.theme_type === "1"
                                ? durationWhiteIcon
                                : durationIcon
                            }
                            alt="Share duration Icon"
                            style={{ maxWidth: "1.6rem" }}
                          />
                          {sections?.[section_index]?.start_date && (
                            <span className="text_regular-gray ml-1">
                              {sections?.[section_index]?.relative_duration
                                ?.is_relative
                                ? `${
                                    moment(
                                      getMtdYtdDuration(
                                        sections?.[section_index]
                                          ?.relative_duration?.relative_type
                                      )?.from
                                    ).format("DD MMM") + " - "
                                  }${moment(
                                    getMtdYtdDuration(
                                      sections?.[section_index]
                                        ?.relative_duration?.relative_type
                                    )?.to
                                  ).format("DD MMM")}`
                                : `${
                                    moment(
                                      sections?.[section_index]?.start_date
                                    ).format("DD MMM") + " - "
                                  }${moment(
                                    sections?.[section_index]?.end_date
                                  ).format("DD MMM")}`}
                            </span>
                          )}
                        </button>
                      </Tooltip>
                    )}

                    {shareTemplateData?.["show_filters"] &&
                    sections[section_index]?.filters?.length > 0 ? (
                      <Popover
                        placement="leftTop"
                        content={() => (
                          <div
                            className="custom_scroll p-2"
                            style={{
                              maxWidth: "27rem",
                              maxHeight: "23rem",
                              overflow: "auto",
                              scrollBehavior: "smooth",
                            }}
                          >
                            <div className="mb-1">
                              {sections &&
                              sections?.[section_index]?.filters?.filter(
                                (e) =>
                                  e?.attribute !== "BrandID" &&
                                  e?.attribute !== "CreatedDate"
                              )?.length ? (
                                sections[section_index]?.filters?.map(
                                  (el, i) => {
                                    return (
                                      el?.attribute !== "BrandID" &&
                                      el?.attribute !== "CreatedDate" && (
                                        <div className="mb-2" key={i}>
                                          <p className="mb-0 text-white">
                                            <strong>
                                              {All_Share_attributes &&
                                              All_Share_attributes[
                                                el?.attribute
                                              ]
                                                ? All_Share_attributes[
                                                    el?.attribute
                                                  ]
                                                : el?.attribute?.toLowerCase() ===
                                                  "categoryid"
                                                ? "Category"
                                                : el?.attribute?.toLowerCase() ===
                                                  "subcategoryid_aug"
                                                ? "Sub Category"
                                                : el?.attribute?.toLowerCase() ===
                                                  "subsubcategoryid"
                                                ? "Sub Sub Category"
                                                : el?.attribute?.replace(
                                                    "Type",
                                                    ""
                                                  )}
                                            </strong>
                                          </p>
                                          {el?.type === "int" &&
                                            !Array.isArray(el?.columns) && (
                                              <span className="font-weight-light text-white">
                                                {el?.columns?.from +
                                                  " - " +
                                                  el?.columns?.to}
                                              </span>
                                            )}
                                          {Array.isArray(el?.columns) &&
                                            el?.columns?.map((e, index) => {
                                              return (
                                                <span
                                                  key={index}
                                                  className="font-weight-light"
                                                  style={{
                                                    color:
                                                      e?.type === "include"
                                                        ? "#5ed66d"
                                                        : e?.type === "exclude"
                                                        ? "#fb7665"
                                                        : "#fff",
                                                  }}
                                                >
                                                  {/* {(index ? ", " : "") +
                                                    (e?.display_name
                                                      ? e?.display_name
                                                      : e?.name)} */}

                                                  {[
                                                    "FeedBackEnabled",
                                                    "ShowDeletedFromSocial",
                                                    "AutoClosureEnabled",
                                                    "IsWorkingHour",
                                                  ]?.includes(el?.attribute)
                                                    ? e?.name === null
                                                      ? "Any"
                                                      : e?.name === 0
                                                      ? "No"
                                                      : e?.name === 1 && "Yes"
                                                    : (index ? ", " : "") +
                                                      (e?.display_name
                                                        ? e?.display_name
                                                        : e?.name)}
                                                </span>
                                              );
                                            })}
                                        </div>
                                      )
                                    );
                                  }
                                )
                              ) : (
                                <div className="mb-0">
                                  <p className="mb-0 text-white">
                                    Section level filters
                                  </p>
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                        color="#3B5175"
                        overlayClassName={
                          authParams?.theme_type === "1"
                            ? "darkTheme"
                            : "lightTheme"
                        }
                      >
                        <Badge
                          style={{
                            backgroundColor: "#185edf",
                            fontSize: "1rem",
                          }}
                          size="small"
                          count={
                            sections[section_index]?.filters
                              ? sections[section_index]?.filters?.filter(
                                  (el) =>
                                    el?.attribute !== "BrandID" &&
                                    el?.attribute !== "CreatedDate"
                                )?.length
                              : 0
                          }
                          className="mr-2"
                        >
                          <button
                            className={`WidgetFilter ${
                              sections[section_index]?.is_locked ? "locked" : ""
                            }`}
                            style={{
                              borderColor:
                                sections && sections[section_index]?.is_locked
                                  ? "#EFE3C0"
                                  : "#678bff33",
                            }}
                            onClick={(e) => {
                              !shareBrands && handleFilter(e);
                              e.stopPropagation();
                              e.nativeEvent?.stopImmediatePropagation();
                            }}
                          >
                            <Avatar
                              shape="square"
                              size="small"
                              src={
                                sections[section_index]?.is_locked
                                  ? WidgetFilterLockIcon
                                  : WidgetFilter
                              }
                              alt="Share Widget Filter"
                            />
                          </button>
                        </Badge>
                      </Popover>
                    ) : (
                      !shareTemplateData?.predefined &&
                      shareTemplateData?.["show_filters"] && (
                        <Tooltip
                          placement="leftTop"
                          overlayStyle={{
                            width:
                              sections && sections[section_index]?.is_locked
                                ? "23rem"
                                : badgeCount
                                ? "22rem"
                                : "15rem",
                          }}
                          color="#3B5175"
                          title={
                            sections && sections[section_index]?.is_locked
                              ? `Section level filters are applied & locked. Global filters won't have any effect.`
                              : badgeCount
                              ? "Section level filters are applied"
                              : `Section level filters`
                          }
                        >
                          <Badge
                            style={{
                              backgroundColor: "#185edf",
                              fontSize: "1rem",
                            }}
                            size="small"
                            count={badgeCount ? badgeCount : 0}
                            className="mr-2"
                          >
                            <button
                              disabled={templateAccessType === 1 ? true : false}
                              className={`WidgetFilter ${
                                sections[section_index]?.is_locked
                                  ? "locked"
                                  : ""
                              }`}
                              style={{
                                borderColor:
                                  sections && sections[section_index]?.is_locked
                                    ? "#EFE3C0"
                                    : "#678bff33",
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                e.nativeEvent?.stopImmediatePropagation();
                              }}
                            >
                              {templateAccessType === 1 ? (
                                <>
                                  <Avatar
                                    shape="square"
                                    size="small"
                                    src={
                                      sections[section_index]?.is_locked
                                        ? WidgetFilterLockIcon
                                        : filterSmall
                                    }
                                    alt="Section Filter 1"
                                  />
                                </>
                              ) : (
                                <>
                                  <Avatar
                                    shape="square"
                                    size="small"
                                    src={
                                      sections[section_index]?.is_locked
                                        ? WidgetFilterLockIcon
                                        : WidgetFilter
                                    }
                                    alt="section Filter 2"
                                  />
                                </>
                              )}
                            </button>
                          </Badge>
                        </Tooltip>
                      )
                    )}

                    {shareBrands &&
                      badgeCount > 0 &&
                      !sections[section_index]?.filters && (
                        <Badge
                          style={{
                            backgroundColor: "#185edf",
                            fontSize: "1rem",
                          }}
                          size="small"
                          count={badgeCount ? badgeCount : 0}
                        >
                          <button
                            className={`WidgetFilter ${
                              sections[section_index]?.is_locked ? "locked" : ""
                            }`}
                            style={{
                              borderColor:
                                sections && sections[section_index]?.is_locked
                                  ? "#EFE3C0"
                                  : "#678bff33",
                            }}
                            onClick={(e) => {
                              !shareBrands && handleFilter(e);
                              e.stopPropagation();
                              e.nativeEvent?.stopImmediatePropagation();
                            }}
                          >
                            <Avatar
                              shape="square"
                              size="small"
                              src={
                                sections[section_index]?.is_locked
                                  ? WidgetFilterLockIcon
                                  : WidgetFilter
                              }
                              alt="Section Filter 3"
                            />
                          </button>
                        </Badge>
                      )}

                    <img
                      src={
                        authParams?.theme_type === "1"
                          ? accoArrowWhite
                          : accoArrow
                      }
                      alt="arrow"
                      className="accordionArrow mr-2"
                      style={{
                        transform: `rotate(${
                          sections?.[section_index]?.open ? "0deg" : "180deg"
                        })`,
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="row ml-0">
                {widgets &&
                  sections?.[section_index]?.open &&
                  widgets?.map((el, i) => {
                    return (
                      <Widget
                        key={el?.widget_id + i}
                        data={el}
                        section_index={section_index}
                        nextWidgetdata={widgets?.[i + 1]}
                        prevWidgetdata={widgets?.[i - 1]}
                        widget_index={i}
                        widget_graph_type={el?.graph_type}
                        section_id={section_id}
                        sections={sections}
                        columnSpan={columnSpan}
                        widget_id={el?.widget_id}
                      />
                    );
                  })}
              </div>
            </>
          ) : (
            <>
              <div
                className={`section-title p-10 ${
                  authParams?.theme_type === "1" ? "" : "border"
                } border-color border-radius-4 cursor-pointer mb-15 ${
                  PdfDownloadStatus ? "d-none" : ""
                }`}
                // style={{
                //   backgroundColor:
                //     authParams?.theme_type === "1"
                //       ? "rgb(59 81 117 / 50%)"
                //       : "var(--locobuzz-secondary-bg-lighter-color)",
                // }}
                onClick={() => openSection(section_index)}
              >
                <div className="row">
                  <div
                    className={`col-12 d-flex align-items-center ${
                      isWidgetEdit ? "col-md-12" : "col-md-9"
                    }`}
                  >
                    <div>
                      <div className="text_heading-Slab font-size16 font-weight500 d-inline-flex align-items-center">
                        {title}
                        <div
                          className="ml-15 d-inline-flex align-items-center"
                          //style={{ minHeight: "2.6rem" }}
                        >
                          {Array.isArray(competitorBrandFilterPills) &&
                            competitorBrandFilterPills?.map((comFil) => {
                              return (
                                <div
                                  className="combrand__filter--pills border-radius-25 text-ellipsis"
                                  style={{
                                    border:
                                      "0.1rem solid " + comFil?.brand_color,
                                  }}
                                >
                                  <Tooltip
                                    placement="topLeft"
                                    className="text-ellipsis d-block"
                                    title={comFil?.brand_friendly_name}
                                  >
                                    <span>
                                      <span
                                        className="combrand__filter--color"
                                        style={
                                          comFil?.brand_color
                                            ? {
                                                backgroundColor:
                                                  comFil?.brand_color,
                                              }
                                            : {
                                                border:
                                                  "0.1rem solid var(--secondary-color)",
                                              }
                                        }
                                      ></span>
                                      <span className="">
                                        {comFil?.brand_friendly_name}
                                      </span>
                                    </span>
                                  </Tooltip>
                                </div>
                              );
                            })}
                        </div>
                      </div>
                      <div
                        className={`text_regular-gray font-size14 ${
                          /\s/g?.test(description) ? "break-word" : "break-all"
                        } line-height-normal`}
                      >
                        {description}
                      </div>
                    </div>
                  </div>
                  <div
                    className={`col-12 col-md-3 text-right ${
                      isWidgetEdit
                        ? "d-none"
                        : "d-flex align-items-center justify-content-end"
                    }`}
                  >
                    {!widgets && sections?.[section_index]?.open && (
                      <Spin indicator={antIcon} className="mr-15" />
                    )}
                    {finalBrand_list ? (
                      <Tooltip
                        overlayStyle={{
                          maxWidth: "20rem",
                        }}
                        color="#3B5175"
                        //className="custom_scroll"
                        placement="leftTop"
                        title={() => (
                          //todo
                          <div
                            className="custom_scroll"
                            style={{
                              maxWidth: "27rem",
                              maxHeight: "23rem",
                              overflow: "auto",
                              scrollBehavior: "smooth",
                            }}
                          >
                            {sections[section_index]?.brand_ids &&
                            sections[section_index]?.brand_ids?.columns
                              ?.length === Allbrands?.length
                              ? "All Brands selected"
                              : finalBrand_list
                              ? finalBrand_list?.columns?.map((el, index) => (
                                  <span
                                    key={index}
                                    style={{
                                      color: "#fff",
                                      maxHeight: "20rem",
                                      overflow: "auto",
                                    }}
                                  >
                                    {(index ? ", " : "") +
                                      el?.brand_friendly_name}
                                  </span>
                                ))
                              : "Section level brands"}
                          </div>
                        )}
                      >
                        <Badge
                          style={{
                            backgroundColor: "#185edf",
                            fontSize: "1rem",
                          }}
                          size="small"
                          count={finalBrand_list?.columns?.length}
                          className="mr-2 custom_scroll vertical-align-middle"
                        >
                          <button
                            className={`WidgetFilter ${
                              sections[section_index]?.is_locked &&
                              finalBrand_list?.columns?.length > 0
                                ? "locked"
                                : ""
                            }`}
                            onClick={(e) => {
                              e.stopPropagation();
                              e.nativeEvent?.stopImmediatePropagation();
                            }}
                            style={{
                              borderColor:
                                sections[section_index]?.is_locked &&
                                finalBrand_list?.columns?.length > 0
                                  ? "#efe3c0"
                                  : "",
                            }}
                          >
                            <Image
                              src={
                                finalBrand_list?.columns?.[0]?.group
                                  ? brandlogicalgroup?.filter(
                                      (el, i) =>
                                        el?.brand_group_name ===
                                        finalBrand_list?.columns?.[0]
                                          ?.brand_group_name
                                    )?.[0]?.brand_logo_image
                                  : finalBrand_list?.columns?.[0]?.brand_logo
                                  ? finalBrand_list?.columns?.[0]?.brand_logo
                                  : Default_Brand
                              }
                              alt="Brand"
                              fallback={Default_Brand}
                              style={{ maxWidth: "1.6rem" }}
                              preview={false}
                            />
                          </button>
                        </Badge>
                      </Tooltip>
                    ) : (
                      !shareBrands &&
                      !panes[index]?.predefined && (
                        <Tooltip
                          overlayStyle={{
                            maxWidth: "20rem",
                          }}
                          color="#3B5175"
                          //className="custom_scroll"
                          placement="leftTop"
                          title={() => (
                            <div
                              className="custom_scroll"
                              style={{
                                maxWidth: "27rem",
                                maxHeight: "23rem",
                                overflow: "auto",
                                scrollBehavior: "smooth",
                              }}
                            >
                              {sections[section_index]?.brand_list &&
                              sections[section_index]?.brand_list?.columns
                                ?.length === Allbrands?.length
                                ? "All Brands selected"
                                : sections[section_index]?.brand_list
                                ? sections[
                                    section_index
                                  ]?.brand_list?.columns?.map((el, index) => (
                                    <p
                                      key={index}
                                      style={{
                                        color: "#fff",
                                        maxHeight: "20rem",
                                        overflow: "auto",
                                      }}
                                    >
                                      {el?.brand_friendly_name}
                                    </p>
                                  ))
                                : "Section level brands"}
                            </div>
                          )}
                        >
                          <Badge
                            style={{
                              backgroundColor: "#185edf",
                              fontSize: "1rem",
                            }}
                            size="small"
                            count={
                              finalBrand_list?.columns?.[0]?.group
                                ? brandlogicalgroup?.filter(
                                    (el, i) =>
                                      el?.brand_group_name ===
                                      finalBrand_list?.columns?.[0]
                                        ?.brand_group_name
                                  )?.length
                                : finalBrand_list?.columns?.[0]?.brand_logo
                                ? finalBrand_list?.columns?.length
                                : 0
                            }
                            className="mr-2 custom_scroll vertical-align-middle"
                          >
                            <button
                              className={`WidgetFilter ${
                                sections[section_index]?.is_locked &&
                                finalBrand_list?.columns?.length > 0
                                  ? "locked"
                                  : ""
                              }`}
                              onClick={(e) => {
                                e.stopPropagation();
                                e.nativeEvent?.stopImmediatePropagation();
                              }}
                              style={{
                                borderColor:
                                  sections[section_index]?.is_locked &&
                                  finalBrand_list?.columns?.length > 0
                                    ? "#efe3c0"
                                    : "",
                              }}
                            >
                              <Image
                                src={
                                  finalBrand_list?.columns?.[0]?.group
                                    ? brandlogicalgroup?.filter(
                                        (el, i) =>
                                          el?.brand_group_name ===
                                          finalBrand_list?.columns?.[0]
                                            ?.brand_group_name
                                      )?.[0]?.brand_logo_image
                                    : finalBrand_list?.columns?.[0]?.brand_logo
                                    ? finalBrand_list?.columns?.[0]?.brand_logo
                                    : Default_Brand
                                }
                                alt="Brand"
                                fallback={Default_Brand}
                                style={{ maxWidth: "1.6rem" }}
                                preview={false}
                              />
                            </button>
                          </Badge>
                        </Tooltip>
                      )
                    )}
                    {/* Last $
{moment(sections[section_index]?.start_date).diff(
moment(sections[section_index]?.end_date),
"days"
)}{" "}
days, */}
                    {sections[section_index]?.start_date ? (
                      <Tooltip
                        placement="leftTop"
                        overlayStyle={{ width: "23rem" }}
                        color="#3B5175"
                        title={
                          sections && sections[section_index]?.start_date
                            ? `${
                                moment(
                                  sections[section_index]?.start_date
                                ).format("MMM Do YYYY HH:mm") + " to "
                              }${moment(
                                sections[section_index]?.end_date
                              ).format("MMM Do YYYY HH:mm")}`
                            : "Section level duration"
                        }
                      >
                        <button
                          className={`WidgetFilter mr-2 ${
                            sections[section_index]?.is_locked &&
                            sections[section_index]?.start_date
                              ? "locked"
                              : ""
                          }`}
                          onClick={(e) => {
                            e.stopPropagation();
                            e.nativeEvent?.stopImmediatePropagation();
                          }}
                          style={{
                            borderColor:
                              sections[section_index]?.is_locked &&
                              sections[section_index]?.start_date
                                ? "#efe3c0"
                                : "",
                          }}
                        >
                          <img
                            src={
                              sections[section_index]?.is_locked &&
                              sections[section_index]?.start_date
                                ? durationIconGold
                                : authParams?.theme_type === "1"
                                ? durationWhiteIcon
                                : durationIcon
                            }
                            alt="duration Icon"
                            style={{ maxWidth: "1.6rem" }}
                          />
                          {sections && sections[section_index]?.start_date && (
                            <span className="text_regular-gray ml-1">
                              {`${
                                moment(
                                  sections[section_index]?.start_date
                                ).format("DD MMM") + " - "
                              }${moment(
                                sections[section_index]?.end_date
                              ).format("DD MMM")}`}
                            </span>
                          )}
                        </button>
                      </Tooltip>
                    ) : (
                      !shareBrands &&
                      !panes[index]?.predefined && (
                        <Tooltip
                          placement="leftTop"
                          overlayStyle={{ width: "23rem" }}
                          color="#3B5175"
                          title={
                            sections &&
                            sections[section_index]?.dateFilters?.length > 0 ? (
                              <div>
                                <span className="d-block">
                                  Section level duration applied
                                </span>
                                <span>
                                  {moment(
                                    sections[section_index]?.dateFilters[0]
                                      ?.columns?.from
                                  ).format("Do MMM YYYY HH:mm") + " to "}
                                  {moment(
                                    sections[section_index]?.dateFilters[0]
                                      ?.columns?.to
                                  ).format("Do MMM YYYY HH:mm")}
                                </span>
                              </div>
                            ) : (
                              "Section level duration"
                            )
                          }
                        >
                          <button
                            className={`WidgetFilter mr-2 ${
                              sections[section_index]?.is_locked &&
                              sections?.[section_index]?.dateFilters?.[0]
                                ?.columns?.from
                                ? "locked"
                                : ""
                            }`}
                            onClick={(e) => {
                              e.stopPropagation();
                              e.nativeEvent?.stopImmediatePropagation();
                            }}
                            style={{
                              borderColor:
                                sections[section_index]?.is_locked &&
                                sections?.[section_index]?.dateFilters?.[0]
                                  ?.columns?.from
                                  ? "#efe3c0"
                                  : "",
                            }}
                          >
                            <img
                              src={
                                sections[section_index]?.is_locked &&
                                sections?.[section_index]?.dateFilters?.[0]
                                  ?.columns?.from
                                  ? durationIconGold
                                  : authParams?.theme_type === "1"
                                  ? durationWhiteIcon
                                  : durationIcon
                              }
                              alt="duration Icon"
                              style={{ maxWidth: "1.6rem" }}
                            />
                            {sections?.[section_index]?.dateFilters?.length >
                              0 && (
                              <span className="text_regular-gray ml-1">
                                {`${
                                  moment(
                                    sections?.[section_index]?.dateFilters?.[0]
                                      ?.columns?.from
                                  ).format("DD MMM") + " - "
                                }${moment(
                                  sections?.[section_index]?.dateFilters?.[0]
                                    ?.columns?.to
                                ).format("DD MMM")}`}
                              </span>
                            )}
                          </button>
                        </Tooltip>
                      )
                    )}

                    <span
                      className={`${
                        graphLoader || aggregateLoader || profileLoader
                          ? "disable"
                          : ""
                      }`}
                    >
                      {sections[section_index]?.filters?.length > 0 ? (
                        <Popover
                          placement="leftTop"
                          content={() => (
                            <div
                              className="custom_scroll p-2"
                              style={{
                                maxWidth: "27rem",
                                maxHeight: "23rem",
                                overflow: "auto",
                                scrollBehavior: "smooth",
                              }}
                            >
                              <div className="mb-1">
                                {sections &&
                                sections?.[section_index]?.filters?.filter(
                                  (e) =>
                                    e?.attribute !== "BrandID" &&
                                    e?.attribute !== "CreatedDate"
                                )?.length ? (
                                  sections[section_index]?.filters?.map(
                                    (el, i) => {
                                      return (
                                        el?.attribute !== "BrandID" &&
                                        el?.attribute !== "CreatedDate" && (
                                          <div className="mb-2" key={i}>
                                            <p className="mb-0 text-white">
                                              <strong>
                                                {All_Share_attributes &&
                                                All_Share_attributes[
                                                  el?.attribute
                                                ]
                                                  ? All_Share_attributes[
                                                      el?.attribute
                                                    ]
                                                  : el?.attribute?.toLowerCase() ===
                                                    "categoryid"
                                                  ? "Category"
                                                  : el?.attribute?.toLowerCase() ===
                                                    "subcategoryid_aug"
                                                  ? "Sub Category"
                                                  : el?.attribute?.toLowerCase() ===
                                                    "subsubcategoryid"
                                                  ? "Sub Sub Category"
                                                  : el?.attribute?.replace(
                                                      "Type",
                                                      ""
                                                    )}
                                              </strong>
                                            </p>
                                            {el?.type === "int" &&
                                              !Array.isArray(el?.columns) && (
                                                <span className="font-weight-light text-white">
                                                  {el?.columns?.from +
                                                    " - " +
                                                    el?.columns?.to}
                                                </span>
                                              )}
                                            {Array.isArray(el?.columns) &&
                                              el?.columns?.map((e, index) => {
                                                return (
                                                  <span
                                                    key={index}
                                                    className="font-weight-light"
                                                    style={{
                                                      color:
                                                        e?.type === "include"
                                                          ? "#5ed66d"
                                                          : e?.type ===
                                                            "exclude"
                                                          ? "#fb7665"
                                                          : "#fff",
                                                    }}
                                                  >
                                                    {/* {(index ? ", " : "") +
                                                      (e?.display_name
                                                        ? e?.display_name
                                                        : e?.name)} */}

                                                    {[
                                                      "FeedBackEnabled",
                                                      "ShowDeletedFromSocial",
                                                      "AutoClosureEnabled",
                                                      "IsWorkingHour",
                                                    ]?.includes(el?.attribute)
                                                      ? e?.name === null
                                                        ? "Any"
                                                        : e?.name === 0
                                                        ? "No"
                                                        : e?.name === 1 && "Yes"
                                                      : (index ? ", " : "") +
                                                        (e?.display_name
                                                          ? e?.display_name
                                                          : e?.name)}
                                                  </span>
                                                );
                                              })}
                                          </div>
                                        )
                                      );
                                    }
                                  )
                                ) : (
                                  <div className="mb-0">
                                    <p className="mb-0 text-white">
                                      Section level filters
                                    </p>
                                  </div>
                                )}
                              </div>
                            </div>
                          )}
                          color="#3B5175"
                          overlayClassName={
                            authParams?.theme_type === "1"
                              ? "darkTheme"
                              : "lightTheme"
                          }
                        >
                          <Badge
                            style={{
                              backgroundColor: "#185edf",
                              fontSize: "1rem",
                            }}
                            size="small"
                            count={
                              sections[section_index]?.filters
                                ? sections[section_index]?.filters?.filter(
                                    (el) =>
                                      el?.attribute !== "BrandID" &&
                                      el?.attribute !== "CreatedDate"
                                  )?.length
                                : 0
                            }
                          >
                            <button
                              className="WidgetFilter"
                              style={{
                                borderColor:
                                  sections && sections[section_index]?.is_locked
                                    ? "#EFE3C0"
                                    : "#678bff33",
                              }}
                              onClick={(e) => {
                                !shareBrands &&
                                  templateAccessType != 1 &&
                                  handleFilter(e);
                                e.stopPropagation();
                                e.nativeEvent?.stopImmediatePropagation();
                              }}
                            >
                              <Avatar
                                shape="square"
                                size="small"
                                src={
                                  sections[section_index]?.is_locked
                                    ? WidgetFilterLockIcon
                                    : authParams?.theme_type === "1"
                                    ? filterWhite
                                    : WidgetFilter
                                }
                                alt="Widget Filter 1"
                              />
                            </button>
                          </Badge>
                        </Popover>
                      ) : (
                        !shareBrands &&
                        !panes[index]?.predefined && (
                          <Tooltip
                            placement="leftTop"
                            overlayStyle={{
                              width:
                                sections && sections[section_index]?.is_locked
                                  ? "23rem"
                                  : badgeCount
                                  ? "22rem"
                                  : "15rem",
                            }}
                            color="#3B5175"
                            title={
                              sections && sections[section_index]?.is_locked
                                ? `Section level filters are applied & locked. Global filters won't have any effect.`
                                : badgeCount
                                ? "Section level filters are applied"
                                : `Section level filters`
                            }
                          >
                            <Badge
                              style={{
                                backgroundColor: "#185edf",
                                fontSize: "1rem",
                              }}
                              size="small"
                              count={badgeCount ? badgeCount : 0}
                            >
                              <button
                                // disabled={templateAccessType === 1 ? true : false}
                                className={`WidgetFilter ${
                                  sections[section_index]?.is_locked
                                    ? "locked"
                                    : ""
                                }`}
                                style={{
                                  borderColor:
                                    sections &&
                                    sections[section_index]?.is_locked
                                      ? "#EFE3C0"
                                      : "#678bff33",
                                }}
                                onClick={(e) => {
                                  !shareBrands &&
                                    templateAccessType != 1 &&
                                    handleFilter(e);
                                  e.stopPropagation();
                                  e.nativeEvent?.stopImmediatePropagation();
                                }}
                              >
                                {templateAccessType === 1 ? (
                                  <>
                                    <Avatar
                                      shape="square"
                                      size="small"
                                      src={
                                        sections[section_index]?.is_locked
                                          ? WidgetFilterLockIcon
                                          : authParams?.theme_type === "1"
                                          ? filterWhite
                                          : WidgetFilter
                                      }
                                      alt="Widget Filter 2"
                                    />
                                  </>
                                ) : (
                                  <>
                                    <Avatar
                                      shape="square"
                                      size="small"
                                      src={
                                        sections[section_index]?.is_locked
                                          ? WidgetFilterLockIcon
                                          : authParams?.theme_type === "1"
                                          ? filterWhite
                                          : WidgetFilter
                                      }
                                      alt="Widget Filter 3"
                                    />
                                  </>
                                )}
                              </button>
                            </Badge>
                          </Tooltip>
                        )
                      )}
                    </span>

                    <img
                      src={
                        authParams?.theme_type === "1"
                          ? accoArrowWhite
                          : accoArrow
                      }
                      alt="arrow"
                      className="accordionArrow ml-2 mr-2"
                      style={{
                        transform: `rotate(${
                          sections?.[section_index]?.open ? "0deg" : "180deg"
                        })`,
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="row ml-0">
                {((widgets && sections?.[section_index]?.open) ||
                  (authParams?.ppt && widgets)) &&
                  widgets?.map((el, i) => {
                    return (
                      <Widget
                        key={el?.widget_id + i}
                        data={el}
                        section_index={section_index}
                        widget_index={i}
                        widget_graph_type={el?.graph_type}
                        section_id={section_id}
                        sections={sections}
                        columnSpan={columnSpan}
                        widget_id={el?.widget_id}
                        nextWidgetdata={widgets?.[i + 1]}
                        prevWidgetdata={widgets?.[i - 1]}
                      />
                    );
                  })}
              </div>
            </>
          )}
        </div>
      )}

      {(isWidgetEdit || pdfEditorPanelSatus) && (
        <EditWidget
          section_index={section_index}
          setColumnSpan={setColumnSpan}
        />
      )}
    </>
  );
};

export default React.memo(SectionInsights, isEqual);
